
export default function ProfileSkeleton() {
  return (
    <div className="container py-4 skeleton-wrapper">
      {/* Top Section */}
      <div className="row g-4">
        {/* Left Card */}
        <div className="col-md-4">
          <div className="card p-4 text-center shadow-sm">
            <div className="skeleton-shimmer rounded-circle mx-auto mb-3" style={{ width: "90px", height: "90px" }}></div>
            <div className="skeleton-shimmer col-6 mx-auto mb-2"></div>
            <div className="skeleton-shimmer col-4 mx-auto mb-3"></div>
            <div className="skeleton-shimmer col-12 py-3 rounded"></div>
          </div>
        </div>

        {/* Banner Image */}
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="skeleton-shimmer w-100" style={{ height: "200px" }}></div>
          </div>
        </div>
      </div>

      {/* About Us */}
      <div className="card shadow-sm p-4 mt-4">
        <div className="skeleton-shimmer col-3 mb-3"></div>
        <div className="skeleton-shimmer col-12 mb-2"></div>
        <div className="skeleton-shimmer col-12 mb-2"></div>
        <div className="skeleton-shimmer col-8 mb-2"></div>
        <div className="skeleton-shimmer col-6"></div>
      </div>

      {/* Services Section */}
      <div className="card shadow-sm p-4 mt-4">
        <div className="skeleton-shimmer col-2 mb-3"></div>
        <div className="row g-3">
          {[...Array(6)].map((_, i) => (
            <div className="col-6 col-md-4 col-lg-2" key={i}>
              <div className="skeleton-shimmer col-12 py-3 rounded"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Stats Section */}
      <div className="row g-3 mt-4">
        {[...Array(3)].map((_, i) => (
          <div className="col-4" key={i}>
            <div className="card p-3 shadow-sm">
              <div className="skeleton-shimmer col-6 mb-2"></div>
              <div className="skeleton-shimmer col-3"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* Shimmer Effect Class */
const styles = `
.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}
@keyframes shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
`;

if (typeof document !== "undefined" && !document.getElementById("skeleton-styles")) {
  const styleEl = document.createElement("style");
  styleEl.id = "skeleton-styles";
  styleEl.innerHTML = styles;
  document.head.appendChild(styleEl);
}
